import qs from "qs";
import {getJsonData} from "./fetchApi";

const exportUrl = process.env.VUE_APP_BACKEND_SERVER + 'api/returns/export';

function getAvailableReturnsExports() {
    return getJsonData(exportUrl);
}

async function downloadReturnsExport(type, params) {
    const headers = new Headers();
    if (localStorage.token) {
        headers.set('Authorization', 'Bearer ' + localStorage.token);
    }

    const query = qs.stringify({filter: params.filter, orderBy: params.orderBy, order: params.order});
    const response = await fetch(exportUrl + '/' + encodeURIComponent(type) + (query ? '?' + query : ''), {
        method: 'GET',
        headers: headers
    });

    if (!response.ok) {
        let message = '';
        try {
            message = (await response.json()).message || '';
        } catch (e) {
            // non-JSON error body
        }
        const error = new Error(message);
        error.status = response.status;
        throw error;
    }

    const disposition = response.headers.get('Content-Disposition') || '';
    const match = /filename="?([^";]+)"?/i.exec(disposition);
    const filename = match ? match[1] : 'returns_' + type + '.xlsx';

    const url = URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}

export {getAvailableReturnsExports, downloadReturnsExport}
